import shuffle from 'lodash/shuffle';
import { getReportedQuestion } from 'pathfinder/modules/QuizConsumptionModule/helpers/reportedQuestionsHelper';
export function randomizeAnswers(quiz) {
    const quizObject = JSON.parse(JSON.stringify(quiz));
    quizObject.questions.forEach((question) => {
        question.answers = shuffle(question.answers);
    });
    return Object.assign({}, quizObject);
}
export function deleteQuestion(quiz, questionId) {
    const questions = quiz.questions.filter((question) => {
        return question.id !== questionId;
    });
    return Object.assign(Object.assign({}, quiz), { questions });
}
export function deletePreviouslyReportedQuestions(quiz) {
    const reportedQuestions = getReportedQuestion();
    let filteredQuestions;
    if (reportedQuestions) {
        filteredQuestions = quiz.questions.filter((question) => {
            var _a;
            return !((_a = reportedQuestions[quiz.id]) === null || _a === void 0 ? void 0 : _a.includes(question.id));
        });
    }
    return Object.assign(Object.assign({}, quiz), (filteredQuestions && { questions: filteredQuestions }));
}
export function deleteAnswersToReportedQuestions(answers, reportedQuestionId) {
    return answers.filter((answer) => {
        return answer.questionId !== reportedQuestionId;
    });
}
